export default "__VITE_ASSET__BrJ79taJ__"